import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import { addNewGameTag, editGameTag } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";

const AddEditTagModal = ({
  selectedTag,
  setSelectedTag,
  showModal,
  setShowModal,
  fetchTags,
  pagination,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // // // Close Add Edit Tag Modal
  const handleCloseAddEditModal = () => {
    setSelectedTag({});
    setShowModal(false);
  };
  const tagValidations = Yup.object().shape({
    name: Yup.string()
      .trim()
      .min(2, "Tag name must be at least 2 characters")
      .max(100, "Tag name cannot exceed 100 characters")
      .required("Tag name is required"),
  });

  // // Add Edit Role Logic
  const handleAddEditTag = async (data) => {
    if (selectedTag?.id) {
      if (data.name === selectedTag.name) {
        delete data.name;
      }
      const editResponse = await editGameTag({ id: selectedTag.id, ...data });
      if (editResponse?.status === 200) {
        if (editResponse?.data?.success) {
          await fetchTags(pagination);

          toast.success("Tag has been updated!", { duration: 2000 });
        }
        handleCloseAddEditModal();
      } else {
        handleErrors(editResponse, navigate, "Edit Tag: ");
      }
    } else {
      const addResponse = await addNewGameTag(data);
      if (addResponse?.status === 200) {
        await fetchTags(pagination);

        toast.success("Tag has been added", {
          duration: 2000,
        });
        handleCloseAddEditModal();
      } else {
        handleErrors(addResponse, navigate, "New Tag: ");
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>{selectedTag?.id ? "Edit Tag" : "Add Tag"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            name: selectedTag?.name || "",
            status: selectedTag?.status,
          }}
          validationSchema={tagValidations}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleAddEditTag(values);
            } catch (error) {
              console.log("Error upon Add Update Tag", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Tag Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter tag name"
                  data-testid="Tag-Name"
                  required
                  value={values.name}
                  onChange={handleChange("name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.name && touched?.name ? (
                  <span className="text-danger">{errors?.name}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={values.status}
                  onChange={handleChange("status")}
                  className="bg-dark border-light text-light"
                  data-testid="Tag-Status"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </Form.Select>
              </Form.Group>
              {/* <Button type="submit" variant="light" className="mt-3">
                {selectedRole?.id ? "Save Changes" : "Add Role"}
              </Button> */}
              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedTag?.id ? "Update" : "Add New Tag"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
export default AddEditTagModal;
